import { StyledBubbleItem } from "./style";
import { Icon } from "components/icon/Icon";
import { Util } from "utils";

type UserBubbleProps = {
  content: string;
  originalText: string;
  createdAt: string;
  reloadable?: boolean;
  reloadMessage?: (originalText: string) => void;
};

const UserBubble = ({
  content,
  originalText,
  createdAt,
  reloadable = false,
  reloadMessage,
}: UserBubbleProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(originalText);
  };

  return (
    <StyledBubbleItem className="user-bubble-container">
      <div className="user-bubble bubble">
        <div
          className="user-bubble-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <div className="chatbot-button-container user">
        <button className="chatbot-button" onClick={handleCopy}>
          <Icon icon="Copy01" size={8} stroke="--text-gray-4" />
        </button>
        {reloadable && (
          <button
            className="chatbot-button"
            onClick={() => reloadMessage?.(originalText)}
          >
            <Icon icon="RefreshCcw02" size={8} stroke="--text-gray-4" />
          </button>
        )}
        <span className="created-at">{Util.getHHMM(createdAt)}</span>
      </div>
    </StyledBubbleItem>
  );
};

export default UserBubble;
